export const systemMessage = `
I will supply to you a detailed {VOICE-OVER SCRIPT} that will be presented to the user using a text-to-speech technology.
- Treat that script as the primary source of truth: reference its facts, structure, and tone whenever you answer questions.  
- When replying to questions, base your answer on the script first. If the script is silent on a point, use your general knowledge, but keep your response consistent with the talk’s themes and style.
- Do **not** quote the script verbatim or reveal it in full; paraphrase or summarize as needed.
`

export const endMessage =
  'The voice over script was fully presented to the user. From now on, if the user has questions, try to engage more with the user. You are now allowed to ask follow questions. Next, please check with the user if there are any questions.'

export const interruptMessageList = [
  'With that settled, let’s get back to it.',
  'Thanks for the questions; let’s dive back in.',
  'Now that it’s all clear, let\'s keep going',
  'Now that we’re clear, let’s get going.',
  'With that cleared up, let’s keep moving.',
  'Appreciate the questions—let’s jump back in.',
  'Great questions; let’s dive right back.',
  'Loved those questions—time to hop back in.',
  'Solid questions; let’s pick it back up.',
  'Thanks for the curiosity; let’s slide back in.',
  'Awesome questions—let’s swing back to it.',
]
